/* @flow */

import { compose } from 'ramda';
import * as React from 'react';
import { Link } from 'react-router-dom';
import { hasURLProtocol, isURLAnchor, isURLMailto } from '@e180/util/lib/url';

type Props = {
  children: React.Node,
  href?: string,
  className?: string,
  handleClick?: () => void,
  handleMouseOver?: () => void,
  newWindow?: boolean,
};

const BaseLink = ({
  children,
  href,
  className,
  handleClick,
  handleMouseOver,
  newWindow,
}: Props): React.Node => {
  const useAnchorTag =
    href && (hasURLProtocol(href) || isURLAnchor(href) || isURLMailto(href));
  const useButtonTag = !href;

  /*
   |----------------------------------------------------------------------------
   | Event Handlers
   |----------------------------------------------------------------------------
   */

  const onClick = (e: MouseEvent) => {
    const { currentTarget } = e;

    if (
      currentTarget instanceof Element &&
      currentTarget.getAttribute('href') === '#'
    ) {
      e.preventDefault();
    }

    if (handleClick) {
      handleClick(e);
    }
  };

  /*
   |----------------------------------------------------------------------------
   | Elements
   |----------------------------------------------------------------------------
   */

  const props = {
    className,
    children,
    onClick: handleClick ? onClick : null,
    onMouseOver: handleMouseOver || null,
    href: undefined,
    role: undefined,
  };

  if (useAnchorTag) {
    props.href = href || '#';
    props.role = 'button';
  }

  if (useAnchorTag) {
    return <a {...props} target={newWindow ? '_blank' : null} />;
  } else if (useButtonTag) {
    return <button {...props}></button>;
  }

  // $FlowIssue
  return <Link {...props} to={href} />;
};

export default compose(React.memo)(BaseLink);
